import { Component } from "@builder.io/sdk";

export const calendlyThankYouGenericConfig: Component = {
  name: "Calendly Thank You",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Thank You!",
      helperText: "Main heading text displayed at the top",
    },
    {
      name: "appointmentType",
      type: "string",
      defaultValue: "Consultation",
      helperText:
        "Type of appointment that was scheduled (e.g., 'Care Indeed App Demo', 'Consultation')",
    },
    {
      name: "customMessage",
      type: "longText",
      helperText:
        "Custom message to display (optional). If empty, will show default message about checking email",
      defaultValue: "",
    },
    {
      name: "showImage",
      type: "boolean",
      defaultValue: true,
      helperText: "Show the thank you image on the right side",
    },
    {
      name: "redirectUrl",
      type: "string",
      helperText: "URL to redirect to after a delay (optional)",
      defaultValue: "",
    },
    {
      name: "redirectDelay",
      type: "number",
      defaultValue: 0,
      helperText: "Delay in milliseconds before redirecting (0 = no redirect)",
    },
    {
      name: "useUrlParams",
      type: "boolean",
      defaultValue: true,
      helperText:
        "Read schedule data (date, time) from URL search parameters. Enable this when using with Calendly Widget.",
    },
  ],
};
